export class TermTypes {
    public static PRIMARY_AU = 'Primary - AU';
    public static SECONDARY_AU = 'Secondary - AU';
    public static PRIMARY_NZ = 'Primary - NZ';
    public static SECONDARY_NZ= 'Secondary - NZ';
    public static GOCARDLESS_NZ = 'GoCardless - NZ';
}